// global cookie getter
var getCookie = (cname)  => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
        c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
    }
    }
    return "";
}

/**
 * Set Cookie Consent Global Object
 */
var oneTrustBannerShown = function(){
    const oneTrustBannerBox = getCookie('OptanonAlertBoxClosed');
    if (oneTrustBannerBox != '') {
        const oneTrustCookieItems = unescape(getCookie('OptanonConsent'));
        if (oneTrustCookieItems !='') {
        let oneTrustCookie = [];
        const cookieConsent = oneTrustCookieItems.split('&').filter( item => item.includes('groups'));
        cookieConsent[0].split('=')[1].split(',').map( i => {
            const cookie = i.split(':'); oneTrustCookie[cookie[0]] = cookie[1];
        });
        cookieConsentObj = {
            isFunctional: oneTrustCookie['C0003'] === '1' ? true : false,
            isPerformance: oneTrustCookie['C0002'] === '1' ? true : false,
            isTargeted: oneTrustCookie['C0004'] === '1' ? true : false,
        };
        // clear algolia cookie incase of functional cookie consent off
        if (cookieConsentObj?.isFunctional === false){ document.cookie = "_ALGOLIA=; Max-Age=0; path=/; "};
        }
    } else{
        window.cookieConsentObj = {
                isFunctional: true,
                isPerformance: true,
                isTargeted: true
            };
    }
};
oneTrustBannerShown();
window.addEventListener('OneTrustGroupsUpdated',function(){
    oneTrustBannerShown();
});

/**
 * Analytics Helper for MTF
 * 
 */
var MTFAnalytics = (function(){

    const DataController = {
        defaults: {
          ecommerce: {
            items:[]
          },
        },
        push: function (eventData) {
          if (typeof window === 'undefined') return;
          if (typeof dataLayer === 'undefined') return;
          try {
            const dataToPush = Object.assign({}, this.defaults, {
              ...eventData,
              ecommerce: { ...eventData.ecommerce, },
            });
    
            dataLayer.push(dataToPush);
            if (eventData.eventCallback) {
              eventData.eventCallback();
            }
          } catch (err) {
            console.error('Failed push to dataLayer', err);
          }
        },
      };
    return {
        getItemsArrayfromCart: (cartData) => {
            return cartData?.items?.map(item => {
                const {product_title, product_id, price, quantity, handle} = item;
                let category;
                switch(handle){
                    case "create-deploy": category = "individual"; break;
                    case "create-pitch": category = "agency"; break;
                    default: category = "enterprise"; break;
                }
                return {
                    item_name: product_title,
                    item_id: product_id,
                    price:price/100,
                    currency:cartData.currency,
                    quantity:quantity,
                    item_category:category
                }
            });
        },
        pushLogin: data => {
            const {method, event} = data;
            DataController.push({
                event,
                method
            });
        },
        pushProductImpression: data => {
            const {event, itemName, items} = data;
            DataController.push({
                event,
                item_name: itemName,
                ecommerce: {
                    items
                },
            })
        },
        pushProductClick : data => {
            const {event, itemName, items, callback} = data;
            DataController.push({
                event,
                item_name: itemName,
                ecommerce: {
                    items
                },
                eventCallback: function() {
                    if (callback) {
                        console.log('callback for product click tracking');
                        callback();
                    }
                }
            })
        },
        pushContactInformation: data => {
              const{event, items} =data;
              DataController.push({
                  event,
                  ecommerce: {
                      items
                  }
              })
        },
        pushPaymentInformation: data => {
            const{event,payment_method, items} =data;
            DataController.push({
                event,
                payment_method,
                ecommerce: {
                    items
                }
            })
        },
        // ------- *pushPurchaseInformation* Generated by *chatGPT* -------
        pushPurchaseInformation: data=>{
            const{event,transaction_id,value,tax,currency,coupon,payment_method, items} =data;
            DataController.push({
                event,
                transaction_id,
                value,
                tax,
                currency,
                coupon,
                payment_method,
                ecommerce: {
                    items
                }
            })
        },
    }

})()
